/* Koopgedrag productpagina (Claude): geen maat vooraf gekozen, prijs in de knop, vaste koopbalk op de telefoon */
(function () {
  function start() {
    var kiezer = document.querySelector('product-selector');
    var vorm = document.querySelector('product-form');
    var knop = vorm && vorm.querySelector('.product-selector__submit.no-js-hidden');
    if (!knop) return;
    var sectie = document.querySelector('[data-main-product]') || document.body;
    var balk = document.querySelector('[data-fzk-balk]');
    var balkKnop = balk && balk.querySelector('[data-fzk-balk-knop]');
    var balkMaat = balk && balk.querySelector('[data-fzk-balk-maat]');
    var basis = (window.variantStrings && window.variantStrings.addToCart) || 'In winkelwagen';

    /* Maatgroep: de knoppen onder "Maten" */
    var maatGroep = null;
    if (kiezer) {
      kiezer.querySelectorAll('[data-input-wrapper]').forEach(function (f) {
        if (f.querySelector('.product__swatch--button')) maatGroep = f;
      });
    }
    var maatInputs = maatGroep ? Array.prototype.slice.call(maatGroep.querySelectorAll('input[type="radio"]')) : [];
    var gekozen = true;
    var heeftVariantInUrl = /[?&]variant=/.test(location.search);
    var beschikbaar = maatInputs.filter(function (i) { return !i.disabled; });

    if (maatInputs.length > 1 && beschikbaar.length && !heeftVariantInUrl) {
      gekozen = false;
      maatInputs.forEach(function (i) {
        i.checked = false;
        if (i.nextElementSibling) i.nextElementSibling.classList.remove('is-active');
      });
      sectie.classList.add('fzk-geen-maat');
    }

    var hint = null;
    if (maatGroep) {
      hint = document.createElement('p');
      hint.className = 'fzk-hint';
      hint.setAttribute('role', 'status');
      hint.textContent = 'Kies eerst je maat, dan zetten we hem in je winkelwagen.';
      var swatches = maatGroep.querySelector('.product__swatches');
      (swatches || maatGroep).insertAdjacentElement('afterend', hint);
    }

    function prijs() {
      var v = kiezer && kiezer.currentVariant;
      if (!v || typeof v.price !== 'number') return '';
      return '€ ' + (v.price / 100).toFixed(2).replace('.', ',');
    }
    function gekozenMaat() {
      var c = maatInputs.filter(function (i) { return i.checked; })[0];
      return c ? c.value : '';
    }

    function zetTekst() {
      if (!knop.disabled) {
        knop.textContent = gekozen ? basis + (prijs() ? ' · ' + prijs() : '') : 'Kies je maat';
      }
      if (balkKnop) {
        balkKnop.disabled = knop.disabled;
        balkKnop.textContent = knop.disabled ? knop.textContent : (gekozen ? 'In winkelwagen' : 'Kies je maat');
      }
      if (balkMaat) {
        var p = prijs();
        balkMaat.textContent = gekozen && gekozenMaat() ? 'Maat ' + gekozenMaat() + (p ? ' · ' + p : '') : (p ? p + ' · kies je maat' : 'Kies je maat');
      }
    }

    function naarMaten() {
      if (!maatGroep) return;
      var top = maatGroep.getBoundingClientRect().top + window.pageYOffset;
      var kop = document.querySelector('header');
      window.scrollTo({ top: Math.max(0, top - (kop ? kop.offsetHeight : 0) - 16), behavior: 'smooth' });
      if (hint) hint.classList.add('is-zichtbaar');
      maatGroep.classList.remove('fzk-tik');
      void maatGroep.offsetWidth;
      maatGroep.classList.add('fzk-tik');
    }

    /* Maat gekozen */
    maatInputs.forEach(function (i) {
      i.addEventListener('change', function () {
        if (!i.checked) return;
        gekozen = true;
        sectie.classList.remove('fzk-geen-maat');
        if (hint) hint.classList.remove('is-zichtbaar');
      });
    });

    /* Na elke wijziging zet het thema de knoptekst terug; daarna zetten wij hem goed */
    document.addEventListener('change', function () { setTimeout(zetTekst, 0); });

    /* Bestellen zonder maat: tegenhouden en naar de maten */
    document.addEventListener('submit', function (e) {
      if (gekozen || !vorm.contains(e.target)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      naarMaten();
    }, true);

    /* Vaste koopbalk op de telefoon */
    if (balk && balkKnop) {
      balkKnop.addEventListener('click', function () {
        if (!gekozen) { naarMaten(); return; }
        if (!knop.disabled) knop.click();
      });
      var voorbij = false;
      function toon() {
        var r = knop.getBoundingClientRect();
        voorbij = r.bottom < 0;
        var zien = voorbij;
        balk.classList.toggle('is-zichtbaar', zien);
        balk.setAttribute('aria-hidden', zien ? 'false' : 'true');
        balkKnop.tabIndex = zien ? 0 : -1;
      }
      window.addEventListener('scroll', toon, { passive: true });
      window.addEventListener('resize', toon);
      toon();
    }

    zetTekst();
  }

  /* Pas starten als het thema de maatkiezer heeft opgezet, anders zet het thema zelf weer een maat aan */
  function klaar() {
    if (window.customElements && !customElements.get('product-selector') && document.querySelector('product-selector')) {
      customElements.whenDefined('product-selector').then(function () { setTimeout(start, 0); });
    } else start();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', klaar);
  else klaar();
})();
